/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetReplacement
 */
export interface AssetReplacement {
    /**
     * 
     * @type {string}
     * @memberof AssetReplacement
     */
    scId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetReplacement
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetReplacement
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof AssetReplacement
     */
    symbol?: string;
}

/**
 * Check if a given object implements the AssetReplacement interface.
 */
export function instanceOfAssetReplacement(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "scId" in value;
    isInstance = isInstance && "sId" in value;

    return isInstance;
}

export function AssetReplacementFromJSON(json: any): AssetReplacement {
    return AssetReplacementFromJSONTyped(json, false);
}

export function AssetReplacementFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetReplacement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'scId': json['sc_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'sId': json['s_id'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
    };
}

export function AssetReplacementToJSON(value?: AssetReplacement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sc_id': value.scId,
        'description': value.description,
        's_id': value.sId,
        'symbol': value.symbol,
    };
}

